<script setup>
import 'filepond-plugin-get-file/dist/filepond-plugin-get-file.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
import 'filepond/dist/filepond.min.css'
import { API_HEADER } from 'js/modules/axios'
import { create, registerPlugin } from 'filepond'
import { i18n } from 'js/vue/i18n'
import { NotifyError } from 'js/vue/boot/Notify'
import { onMounted, ref } from 'vue'
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginGetFile from 'js/vue/boot/filepondPluginGetFile.js'
// import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
// import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginFileRename from 'filepond-plugin-file-rename'

const { id, labelIdle, onData, url, rowId, onRevert, files, onClickFile } =
  defineProps({
    id: {
      type: String,
      default: 'filepod_' + Math.floor(Math.random() * 100) + 1,
    },
    labelIdle: {
      default: '',
      type: String,
    },
    onData: {
      type: Function,
      default: () => null,
    },
    onRevert: {
      type: Function,
      default: () => null,
    },
    onClickFile: {
      type: Function,
      default: () => null,
    },

    url: {
      type: String,
    },
    files: {
      type: Object,
    },
  })

const { tm } = i18n.global

const translations = tm('filepond')

const emit = defineEmits(['update:modelValue'])

registerPlugin(
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize,
  FilePondPluginGetFile,
  FilePondPluginFileRename
  // FilePondPluginImagePreview,
  // FilePondPluginImageExifOrientation,
)

const pond = ref(null)

onMounted(async () => {
  const fileInput = document.querySelector('#' + id)
  pond.value = create(fileInput, {
    ...translations,
    name: 'arquivo',
    storeAsFile: true,
    dropOnPage: true,
    allowMultiple: true,
    credits: null,
    instantUpload: true,
    allowRevert: true,
    allowProcess: false,
    // chunkUploads: true,
    labelIdle,
  files,
    allowDownloadByUrl: true, // by default downloading by URL disabled
    onprocessfilerevert(obj) {
      pond.value.removeFile(obj.id)
    },

    fileRenameFunction: (file) => {
      const { basename, extension } = file
      return `${basename.slice(0, 80)}${extension}`
    },

    server: {
      url: window.location.origin,
      timeout: null,
      revert: async (jsonString) => onRevert(jsonString),
      process: {
        url,
        method: 'POST',
        headers: API_HEADER,
        ondata: onData,
        onerror: (response) => {
          const parsedResponse = JSON.parse(response)
          NotifyError(parsedResponse.error)
        },
      },
    },
  })

  /* 
  document.addEventListener('FilePond:initfile', (e) => {
   debugger
  }) */
})

defineExpose({
  pond,
})
</script>

<template>
  <input :id="id" type="file" />
</template>

<style lang="scss">
/* .filepond--file-wrapper,
.filepond--file-action-button {
  cursor: pointer;
} */
.filepond--download-icon {
  margin-right: 0.25rem;
}
</style>
